import secureLocalStorage from "react-secure-storage";
import { functions } from "./ApplicationAPI/applicationApi";
import secureSessionStorage from "../../utils/secureSessionStorage";

if( !iforms )
    var iforms = {};
let valueChanged = false;

if(!iforms.ajax)
{
    iforms.ajax =
    {        
        strResponse:null,
        url : null, 
        objReq: {},
        processRequest:function(pParam,pUrl,sync)
        {   
            iforms.ajax.url = pUrl;  
            valueChanged = true;
            this.strResponse = null;
            this.sendRequest(pUrl, pParam,sync);            
                   
            return this.strResponse;
        },
        createXMLHttpRequest:function()
        {
            try
            {
                return new XMLHttpRequest();
            } 
            catch(e)
            {}
            console.log("XMLHttpRequest not supported");
            return null;
        },

        sendRequest:function(pUrl,pData,sync)
        {           
            const secureAutherization = secureSessionStorage.getItem("Authorization");        
            const secureNgsmtoken = secureLocalStorage.getItem("ngsmtoken");
            console.log("ajax sync1", secureNgsmtoken, secureAutherization, document, window.isPortalLive)    
            const secureAutherization1 = window.isPortalLive
            ? secureLocalStorage.getItem(`launchpadKey_${window.applicationName}`) || secureLocalStorage.getItem("launchpadKey")
            : secureLocalStorage.getItem("launchpadKey");
            const jwtToken = secureAutherization || JSON.parse(secureAutherization1)?.token || secureSessionStorage.getItem("Authorization") || undefined;
            const externalIformUrl = document?.URL || document?.baseURI || document?.documentURI;
            const ngsmtoken = window.isPortalLive || externalIformUrl?.includes("openExtInterface") ? secureNgsmtoken : undefined;
            console.log("ajax sync2", ngsmtoken, externalIformUrl)
            iforms.ajax.strResponse = "";
            iforms.ajax.strResponse2 = "";
            iforms.ajax.objReq = this.createXMLHttpRequest();
            iforms.ajax.objReq.open("POST", `${window.apb_backend_app_context ? window.apb_backend_app_context: window?.["psh_configs"]?.backEndUrl}${pUrl}`, !sync);
            if (window.isPortalLive || externalIformUrl?.includes("openExtInterface")){
                if(ngsmtoken)
                iforms.ajax.objReq.setRequestHeader("ngsmtoken",ngsmtoken);
            }
            console.log("ajax sync3", iforms.ajax.objReq)
            iforms.ajax.objReq.setRequestHeader("Authorization",jwtToken);
            iforms.ajax.objReq.setRequestHeader("cabinetName",window.activeCabinet_formbuilder);
            iforms.ajax.objReq.setRequestHeader("Content-Type","application/json");
            iforms.ajax.objReq.setRequestHeader("withCredentials",true);
            iforms.ajax.objReq.onreadystatechange = this.onResponse;
            iforms.ajax.objReq.send(pData);
        },

        onResponse:function()
        { 
            try 
            {            
                    if (iforms.ajax.objReq.readyState==4) 
                    {   
                        if (iforms.ajax.objReq.status==200)
                            {        
                                const data = JSON.parse(iforms.ajax.objReq.responseText);
                                if(data.API === "APIError") {
                                    functions.showSplitMessage("Error","Invalid Date Format","error",true,true,[]);
                                }
                                iforms.ajax.strResponse = { data: data};       
                                iforms.ajax.strResponse2 = iforms.ajax.objReq;                     
                            }                      
                    }
                }
            catch(e)
            {
                alert("Error fetching data.");
            }
        }
    }
}

export default iforms;